





























import { vxm } from '../../store.vuex';
import { Component, Vue, Prop } from 'vue-property-decorator';
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 7000,
});

@Component({
  name: 'ConfirmEmailAddrress',
  components: {},
})
export default class ConfirmEmailAddrress extends Vue {
  $wlToastr: any;
  private displayMessage: string = '';

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public confirmEmailAddrress(hash) {
    vxm.users.confirmEmailAddrress(hash).then((res) => {
      console.log('res -- ' + res);
      if (res.success) {
        this.displayMessage = res.successMessage;
        this.$wlToastr('success', this.$t(this.displayMessage));
        return true;
      } else {
        this.displayMessage = res.errorMessage;
        this.$wlToastr('success', this.$t(this.displayMessage));
        return false;
      }
    });
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  mounted() {
    const emailValidationCode = this.$route.query.emailValidationCode + '';
    console.log('code is:' + emailValidationCode);
    this.confirmEmailAddrress(emailValidationCode);
  }
}
